export default class Colors {
  static WHITE = "#fff";

  static BLACK = "#000";

  static MEDIUM_DARK = "#8c96a0";

  static POSITIVE = "#17c671";

  static NEGATIVE = "#c4173c";

  static WARNING = "#ffb400";

  static HIGHLIGHT = "#007bff";
}
